<template>
  <project-manager-layout ref="pmLayoutRef" :spinning="isLoading">
    <leader-project-layout :model="model">
      <template #underInfo>
        <div class="leader-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :show-percent="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>

      <task-item-list
        ref="taskListRef"
        :task-status="PROJECT_TASK_STATUS_ALL"
        :project-status-id="model.projectStatusId"
        :show-availability="!!model.partnerId"
        @update="onUpdate"
      />
      <drawer-right v-model="isShowForm" @close="onDrawerClose">
        <task-form 
          :projectId="parseInt(route.params.id)"
          @updated="onAddTask"
        />
      </drawer-right>
      <div
        v-if="!disabled"
        style="cursor: pointer; position: fixed; bottom: 0; right: 0"
        @click="showForm"
      >
        <img src="@/assets/icons/circle-plus-fill.svg" alt="" />
      </div>
    </leader-project-layout>
  </project-manager-layout>
</template>

<script setup>
  import { computed, onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import LeaderProjectLayout from '@/views/leader/projects/components/LeaderProjectLayout.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';
  import { PROJECT_TASK_STATUS_ALL } from '@/api/models/ProjectTaskStatus';
  import TaskItemList from '@/components/projects/management/TaskItemList.vue';
  import {
    PROJECT_STATUS_ACCEPTANCE,
    PROJECT_STATUS_CLOSED,
  } from '@/api/models/ProjectStatus';
  import TaskForm from '@/components/projects/management/Task/TaskForm.vue';
  import DrawerRight from '@/components/drawers/components/DrawerRight.vue';

  const api = useApi();
  const route = useRoute();
  const isShowForm = ref(false);
  const model = reactive({
    id: null,
    projectStatusId: null,
    isExternal: false,
    partnerId: null,
    isMyProject: false,
    number: '',
    name: '',
    description: '',
    projectType: '',
    requestId: null,
    status: null,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const isLoading = ref(true);
  const taskListRef = ref(null);
  const pmLayoutRef = ref(null);

  const disabled = computed(() => {
    return [PROJECT_STATUS_ACCEPTANCE, PROJECT_STATUS_CLOSED].includes(
      model.projectStatusId
    );
  });

  onMounted(async () => {
    await getModel();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.leaderPage.view(route.params.id);
      model.name = response.project.name;
      model.number = response.project.id;
      model.id = response.project.id;
      model.type = response.project.type;
      model.projectStatusId = response.project.projectStatusId;
      model.isExternal = response.project.isExternal;
      model.partnerId = response.project.partnerId;
      model.isMyProject = response.project.isMyProject;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const onDrawerClose = () => {
    isShowForm.value = false;
  };

  const onUpdate = async () => {
    await taskListRef.value.updateTasks();
    await getModel();
    await pmLayoutRef.value.updateCounters();
  };

  const onAddTask = async () => {
    isShowForm.value = false;
    await taskListRef.value.updateTasks();
  };

  const showForm = () => {
    isShowForm.value = true;
  };
</script>

<style lang="scss" scoped>
  @use 'leader-project-management.scss';
</style>
